import { styles } from "./NavigationGroup.css.ts";

/**
 * Renders a schedule group title, eg. "Discover" with the corresponding symbol.
 *
 * @param {Object} groupState - The state of the group.
 * @param {string} label - The label for the group.
 * @param {Icon} Icon - The icon component to be rendered.
 * @return {JSX.Element} The rendered schedule group title.
 */
export function NavigationGroupTitle({ groupState, label, Icon }) {
  return (
    <div className={styles.navigationGroupTitle({ groupState: groupState })}>
      {Icon && (
        <svg
          width="50"
          height="50"
          viewBox="0 0 112 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.groupIcon}
        >
          <circle
            cx="56"
            cy="56"
            r="56"
            fill={styles.groupStateColors[groupState]}
          />
          <g fill="#000">
            <Icon />
          </g>
        </svg>
      )}
      <h2 className={Icon && styles.hideNavigationGroupLabelIfSmall}>
        {label}
      </h2>
    </div>
  );
}
